import * as types from '@constants';
import { SetThemeType } from 'actionCreators';

export type ThemeInitialStateType = {
  currentTheme: string;
};

const initialState = {
  currentTheme: types.THEMES.DARK, // Changed from DEFAULT to DARK
};

export default function reducer(state = initialState, actions: ActionTypes): ThemeInitialStateType {
  if (actions.type === types.THEME_SET) {
    return {
      ...state,
      currentTheme: actions.payload,
    };
  }
  return state;
}

type ActionTypes = SetThemeType;
